import { graphql, useStaticQuery } from 'gatsby'
import { shouldExcludeByGeoLocation } from '../../utils/shouldExcludeByGeoLocation'
import { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../context/authProvider'

export const useGamesApiData = () => {
  const data = useStaticQuery(graphql`
    {
      allGame {
        nodes {
          created_at
          desktopSlug
          mobileSlug
          title
          slug
          providerName
          providerCode
          providerSlug
          mock
          disable_play_for_fun
          exclude_by_geo_location
          maintenance_mode {
            active_to
            active_from
          }
          thumbnail {
            alt
            url
            title
            sizes {
              medium
              medium_large
              large
            }
          }
          thumbnail_tall {
            alt
            url
            title
            sizes {
              medium
              medium_large
              large
            }
          }
          search_keywords
          game_tags
          gameType
        }
      }
    }
  `)

  const { accessCountry, isLoggedIn } = useContext(AuthContext)
  const allGames = data?.allGame?.nodes

  const filterGames = () => {
    return allGames?.filter(
      (game) =>
        !shouldExcludeByGeoLocation(
          game?.exclude_by_geo_location,
          accessCountry,
          isLoggedIn
        )
    )
  }

  const [games, setGames] = useState(filterGames())

  useEffect(() => {
    const geoBlockedGames = accessCountry ? filterGames() : []
    setGames(geoBlockedGames)
  }, [accessCountry, isLoggedIn, allGames])

  const getGamesByCasinoType = (casinoType) => {
    return games?.filter(
      (game) => game?.gameType?.replace('_', '-') === casinoType
    )
  }

  return { games, getGamesByCasinoType }
}
